import OnboardingStore from 'admin/stores/OnboardingStore';

export const OnboardingServiceModule = angular
    .module('app.components.onboarding.onboardingService', [])
    .factory('onboardingService', ($rootScope) => {
        function handleAsyncResponse(response) {
            $rootScope.$digest();
            return response;
        }

        return {
            getState: force => OnboardingStore.getState(force).then(handleAsyncResponse),
            completeTask: taskId => OnboardingStore.completeTask(taskId).then(handleAsyncResponse),
            dismissHotspot: hotspotId => OnboardingStore.dismissHotspot(hotspotId).then(handleAsyncResponse),
            unlockTask: taskId => OnboardingStore.unlockTask(taskId).then(handleAsyncResponse),
            setShowNextStepNotice: sessionKey => OnboardingStore.setShowNextStepNotice(sessionKey),
            completeInitialTask: (taskId, taskKey) => OnboardingStore.completeInitialTask(taskId, taskKey)
                .then(handleAsyncResponse)
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/onboarding.service.js